var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4766 25.7969C51.3179 25.7969 52 25.1148 52 24.2734V12.8984C52 12.0571 51.3179 11.375 50.4766 11.375C49.4146 11.375 28.668 11.375 27.5234 11.375V1.52344C27.5234 0.682094 26.8413 0 26 0H9.75C8.90866 0 8.22656 0.682094 8.22656 1.52344V11.375H1.52344C0.682094 11.375 0 12.0571 0 12.8984V24.2734C0 25.1148 0.682094 25.7969 1.52344 25.7969H8.22656V34.125H1.52344C0.682094 34.125 0 34.8071 0 35.6484V47.0234C0 47.8648 0.682094 48.5469 1.52344 48.5469H50.4766C51.3179 48.5469 52 47.8648 52 47.0234V35.6484C52 34.8071 51.3179 34.125 50.4766 34.125H43.7734V25.7969H50.4766ZM48.9531 22.75C47.3232 22.75 37.2597 22.75 35.6484 22.75V14.4219H48.9531V22.75ZM32.6016 22.75C31.0059 22.75 21.0046 22.75 19.3984 22.75V14.4219H32.6016V22.75ZM11.2734 3.04688H24.4766V11.375C22.8809 11.375 12.8796 11.375 11.2734 11.375V3.04688ZM3.04688 22.75V14.4219H16.3516V22.75C14.7396 22.75 4.67645 22.75 3.04688 22.75ZM11.2734 25.7969H24.4766V34.125C22.8809 34.125 12.8796 34.125 11.2734 34.125V25.7969ZM3.04688 37.1719H16.3516V45.5H3.04688V37.1719ZM19.3984 37.1719H32.6016V45.5H19.3984V37.1719ZM48.9531 37.1719V45.5H35.6484V37.1719H48.9531ZM40.7266 34.125C39.1309 34.125 29.1296 34.125 27.5234 34.125V25.7969H40.7266V34.125Z",
    fill: "#FF5A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricks);
export default __webpack_public_path__ + "static/media/Bricks.8a76a2b3768623250794a38567f9979d.svg";
export { ForwardRef as ReactComponent };